/**
 * Auto-generated by Style Dictionary from DTCG tokens.
 * DO NOT EDIT — run `nx run tokens:code` to regenerate.
 *
 * @generated
 */

export const typography = {
  fontFamily: '"Inter Variable", Inter, Helvetica, Arial, sans-serif',
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  h1: {
    fontFamily: '"Inter Variable", Inter, Helvetica, Arial, sans-serif',
    fontWeight: 300,
    fontSize: '6rem',
    lineHeight: 1.167,
    letterSpacing: '-0.04687em',
  },
  h2: {
    fontFamily: '"Inter Variable", Inter, Helvetica, Arial, sans-serif',
    fontWeight: 300,
    fontSize: '3.75rem',
    lineHeight: 1.2,
    letterSpacing: '-0.03333em',
  },
  h3: {
    fontFamily: '"Inter Variable", Inter, Helvetica, Arial, sans-serif',
    fontWeight: 300,
    fontSize: '3rem',
    lineHeight: 1.167,
    letterSpacing: '-0.04167em',
  },
  h4: {
    fontFamily: '"Inter Variable", Inter, Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: '2rem',
    lineHeight: 1.235,
    letterSpacing: '-0.01471em',
  },
  h5: {
    fontFamily: '"Inter Variable", Inter, Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: '1.75rem',
    lineHeight: 1.28571429,
    letterSpacing: '0em',
  },
  h6: {
    fontFamily: '"Inter Variable", Inter, Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: '1.375rem',
    lineHeight: 1.6,
    letterSpacing: '-0.025em',
  },
  subtitle1: {
    fontFamily: '"Inter Variable", Inter, Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: '1rem',
    lineHeight: 1.75,
    letterSpacing: '-0.01562em',
  },
  subtitle2: {
    fontFamily: '"Inter Variable", Inter, Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: 1.57,
    letterSpacing: '-0.01786em',
  },
  body1: {
    fontFamily: '"Inter Variable", Inter, Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: 1.5,
    letterSpacing: '-0.03125em',
  },
  body2: {
    fontFamily: '"Inter Variable", Inter, Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: 1.43,
    letterSpacing: '-0.01786em',
  },
  label1: {
    fontFamily: '"Inter Variable", Inter, Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: 1.43,
    letterSpacing: '-0.03125em',
  },
  label2: {
    fontFamily: '"Inter Variable", Inter, Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: 1.2,
    letterSpacing: '-0.01786em',
  },
  label3: {
    fontFamily: '"Inter Variable", Inter, Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: 1.2,
    letterSpacing: '-0.00833em',
  },
  label4: {
    fontFamily: '"Inter Variable", Inter, Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: '0.625rem',
    lineHeight: 1.2,
    letterSpacing: '-0.01em',
  },
  button: {
    fontFamily: '"Inter Variable", Inter, Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: 1.43,
    letterSpacing: '-0.00714em',
    textTransform: 'initial',
  },
  caption: {
    fontFamily: '"Inter Variable", Inter, Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: 1.66,
    letterSpacing: '-0.00833em',
  },
  overline1: {
    fontFamily: '"Inter Variable", Inter, Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: 2.66,
    letterSpacing: '0.03571em',
    textTransform: 'uppercase',
  },
  overline2: {
    fontFamily: '"Inter Variable", Inter, Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: 2.66,
    letterSpacing: '0.04167em',
    textTransform: 'uppercase',
  },
  overline: {
    fontFamily: '"Inter Variable", Inter, Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: 2.66,
    letterSpacing: '0.04167em',
  },
} as const;
